@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.voiceassistant

import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint

object AttachRideToVoiceAssistantSessionEndpoint :
    EndPoint<AttachRideToVoiceAssistantSessionEndpoint.Request, AttachRideToVoiceAssistantSessionEndpoint.Response>() {
    class Request(
        val sessionId: String,
        val rideId: KmmLong,
    )

    class Response(val isAttached: Boolean)
}
